import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'PortfolioDifferenceColumn',
  props: {
    info: null,
    isEsg: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  info: {
    difference: number
    differenceText: string
    hasValue: boolean
  }
  isEsg: boolean
};



const differenceText = computed(() => (props.info && props.info.differenceText) ? props.info.differenceText : '')

const getDifferenceLength = computed(() => Math.abs(props.info.difference).toString().length)

const getColorClass = computed(() => {
  if (props.info?.hasValue) return 'blue-grey--text'
  if (props.info?.difference > 0) return 'success--text'
  else if (props.info?.difference < 0) return 'danger--text'
  else return 'color: #616161 ml-2'
})

const getClass = computed(() => {
  const fontSize = props.isEsg
    ? ' text-md-body-1 font-weight-bold'
    : ' text-caption'
  return getColorClass.value + fontSize
})

return { __sfc: true,props, differenceText, getDifferenceLength, getColorClass, getClass }
}

})